import React, {useContext} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import {IndividualContext} from "../../individual-context.jsx";
import IndividualActivityMap from "../individual-activity-map.jsx";

const ActivityMap = () => {
    const {individual, individualInfo, permissions, boName} = useContext(IndividualContext);

    return (
        <Card>
            <Card.Body className="!p-0">
                <IndividualActivityMap
                    individual={individual}
                    individualInfo={individualInfo}
                    permissions={permissions}
                    boName={boName}
                />
            </Card.Body>
        </Card>
    );
};

export default ActivityMap;
